module.exports = __webpack_public_path__ + "static/media/Dark-logo.6eaecd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/account-setup/Dark-logo.png
// module id = 353
// module chunks = 0